import styled from 'styled-components'

export const Label = styled.p`
  font-size: 0.75rem;
  font-family: Arial, Helvetica, sans-serif;
`